import React from 'react'

import { Attachment } from '~graphql/generated/graphql'
import SharedStack from '~components/shared/wrappers/shared-stack'
import { getAttachmentComponent } from '../../messages-list/attachment-preview'

interface Props {
    attachments: Attachment[]
    onRemoveAttachment: (index: number) => void
}

export default function ChatInputAttachmentsList({
    attachments,
    onRemoveAttachment,
}: Props) {
    if (attachments.length === 0) {
        return null
    }

    return (
        <SharedStack row height="156px" mb={4}>
            {attachments.map((attachment, index) => (
                <React.Fragment
                    key={`${attachment.url}-${attachment.filename}-${index}`}
                >
                    {getAttachmentComponent(
                        attachment,
                        index,
                        onRemoveAttachment,
                    )}
                </React.Fragment>
            ))}
        </SharedStack>
    )
}
